
// This must be a piece of css (don't use scss here)
// use file RichTextEditorInner.css to edit then copy-paste in here
export const richTextEditorInnerStyle = `

/* open-sans-regular - latin */
@font-face {
	font-family: 'Open Sans';
	font-style: normal;
	font-weight: 400;
	src: url('https://cdn.wfp.org/guides/ui/assets/v0.0.1/fonts/open-sans/open-sans-v15-latin-regular.eot');
	/* IE9 Compat Modes */
	src: local('Open Sans Regular'), local('OpenSans-Regular'),
	url('https://cdn.wfp.org/guides/ui/assets/v0.0.1/fonts/open-sans/open-sans-v15-latin-regular.eot?#iefix') format('embedded-opentype'),
	url('https://cdn.wfp.org/guides/ui/assets/v0.0.1/fonts/open-sans/open-sans-v15-latin-regular.woff2') format('woff2'),
	url('https://cdn.wfp.org/guides/ui/assets/v0.0.1/fonts/open-sans/open-sans-v15-latin-regular.woff') format('woff'),
	url('https://cdn.wfp.org/guides/ui/assets/v0.0.1/fonts/open-sans/open-sans-v15-latin-regular.ttf') format('truetype'),
	url('https://cdn.wfp.org/guides/ui/assets/v0.0.1/fonts/open-sans/open-sans-v15-latin-regular.svg#OpenSans') format('svg');
	/* Legacy iOS */
}

/* open-sans-italic - latin */
@font-face {
	font-family: 'Open Sans';
	font-style: italic;
	font-weight: 400;
	src: url('https://cdn.wfp.org/guides/ui/assets/v0.0.1/fonts/open-sans/open-sans-v15-latin-italic.eot');
	/* IE9 Compat Modes */
	src: local('Open Sans Italic'), local('OpenSans-Italic'),
	url('https://cdn.wfp.org/guides/ui/assets/v0.0.1/fonts/open-sans/open-sans-v15-latin-italic.eot?#iefix') format('embedded-opentype'),
	url('https://cdn.wfp.org/guides/ui/assets/v0.0.1/fonts/open-sans/open-sans-v15-latin-italic.woff2') format('woff2'),
	url('https://cdn.wfp.org/guides/ui/assets/v0.0.1/fonts/open-sans/open-sans-v15-latin-italic.woff') format('woff'),
	url('https://cdn.wfp.org/guides/ui/assets/v0.0.1/fonts/open-sans/open-sans-v15-latin-italic.ttf') format('truetype'),
	url('https://cdn.wfp.org/guides/ui/assets/v0.0.1/fonts/open-sans/open-sans-v15-latin-italic.svg#OpenSans') format('svg');
	/* Legacy iOS */
}

/* open-sans-600 - latin */
@font-face {
	font-family: 'Open Sans';
	font-style: normal;
	font-weight: 600;
	src: url('https://cdn.wfp.org/guides/ui/assets/v0.0.1/fonts/open-sans/open-sans-v15-latin-600.eot');
	/* IE9 Compat Modes */
	src: local('Open Sans SemiBold'), local('OpenSans-SemiBold'),
	url('https://cdn.wfp.org/guides/ui/assets/v0.0.1/fonts/open-sans/open-sans-v15-latin-600.eot?#iefix') format('embedded-opentype'),
	url('https://cdn.wfp.org/guides/ui/assets/v0.0.1/fonts/open-sans/open-sans-v15-latin-600.woff2') format('woff2'),
	url('https://cdn.wfp.org/guides/ui/assets/v0.0.1/fonts/open-sans/open-sans-v15-latin-600.woff') format('woff'),
	url('https://cdn.wfp.org/guides/ui/assets/v0.0.1/fonts/open-sans/open-sans-v15-latin-600.ttf') format('truetype'),
	url('https://cdn.wfp.org/guides/ui/assets/v0.0.1/fonts/open-sans/open-sans-v15-latin-600.svg#OpenSans') format('svg');
	/* Legacy iOS */
}

/* open-sans-600italic - latin */
@font-face {
	font-family: 'Open Sans';
	font-style: italic;
	font-weight: 600;
	src: url('https://cdn.wfp.org/guides/ui/assets/v0.0.1/fonts/open-sans/open-sans-v15-latin-600italic.eot');
	/* IE9 Compat Modes */
	src: local('Open Sans SemiBold Italic'), local('OpenSans-SemiBoldItalic'),
	url('https://cdn.wfp.org/guides/ui/assets/v0.0.1/fonts/open-sans/open-sans-v15-latin-600italic.eot?#iefix') format('embedded-opentype'),
	url('https://cdn.wfp.org/guides/ui/assets/v0.0.1/fonts/open-sans/open-sans-v15-latin-600italic.woff2') format('woff2'),
	url('https://cdn.wfp.org/guides/ui/assets/v0.0.1/fonts/open-sans/open-sans-v15-latin-600italic.woff') format('woff'),
	url('https://cdn.wfp.org/guides/ui/assets/v0.0.1/fonts/open-sans/open-sans-v15-latin-600italic.ttf') format('truetype'),
	url('https://cdn.wfp.org/guides/ui/assets/v0.0.1/fonts/open-sans/open-sans-v15-latin-600italic.svg#OpenSans') format('svg');
	/* Legacy iOS */
}

html, body, div, span, applet, object, iframe, h1, h2, h3, h4, h5, h6, p, blockquote, pre, a, abbr, acronym, address, big, cite, code, del, dfn, em, img, ins, kbd, q, s, samp, small, strike, strong, sub, sup, tt, var, b, u, i, center, dl, dt, dd, ol, ul, li, fieldset, form, label, legend, table, caption, tbody, tfoot, thead, tr, th, td, article, aside, canvas, details, embed, figure, figcaption, footer, header, hgroup, menu, nav, output, ruby, section, summary, time, mark, audio, video {
	margin: 0;
	padding: 0;
	border: 0;
	font: inherit;
	font-size: 100%;
	vertical-align: baseline;
}

body {
	font-family: "Open Sans", sans-serif;
	font-weight: 400;
	color: #031c2d;
	text-align: justify;

	padding: 0.5rem;
}

p {
	line-height: 1.5;
	text-align: justify;
}

a {
	color: #0087cb;
}

ul, ol {
	padding-inline-start: 2em;
	line-height: 1.5;
	margin: 0;
}

ul {
	list-style-type: disc;
}

ol {
	list-style-type: decimal;
}

i, em {
	font-style: italic;
}

b, strong {
	font-weight: 600;
}

sup {
	vertical-align: super;
	font-size: smaller;
}

sub {
	vertical-align: sub;
	font-size: smaller;
}

`;
